import {Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges} from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import {CommonService} from "../../core/services/common.service";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() isCondensed = false;
    menu: any;
    menulist: any;
    pathname;

    @ViewChild('sideMenu', {static: false}) sideMenu: ElementRef;

    constructor() {
    }

    ngOnInit() {
        this.pathname = window.location.pathname;
        this.getMenuList();
    }

    getMenuList() {
        this.menulist = [
            {name: 'Hotel Management', link: 'hotel-management', icon: 'remixicon-hotel-bed-line', children: []},
        ];
        if (window.location.pathname.includes("hotels")) {

            this.menulist = [
                /* { name: 'Home Page', link: '/hotels', icon: 'remixicon-home-2-line', children: [] }, */
                {
                    name: 'Dashboard', link: '#', icon: 'remixicon-dashboard-line', slug_name: 'dashboard', children: [
                        {
                            name: 'My Dashboard',
                            link: '/hotels/my-dashboard',
                            icon: 'fa fa-star float-right text-primary'
                        },
                        //{ name: 'Edit My Dashboard', link: '/hotels/edit-my-dashboard' },
                        {name: 'Default Dashboard', link: '/hotels/dashboard'}
                    ]
                },
                {
                    name: 'Quicklinks',
                    link: '/hotels/quicklink',
                    slug_name: 'show-to-all',
                    icon: 'fas fa-link',
                    children: []
                },

                {name: 'Pages', link: '/hotels/cms', slug_name: 'pages', icon: 'remixicon-pages-fill', children: []},

                {
                    name: 'Restaurant', link: '#', icon: 'fas fa-utensils', slug_name: 'restaurant-booking', children: [
                        {name: 'Manage Bookings', link: '/hotels/RestaurantBooking-kanban'},
                        {name: 'Restaurant Booking List', link: '/hotels/RestaurantBookingList'},
                        {name: 'View Bookings', link: '/hotels/RestaurantBooking'},
                        {name: 'Manage Restaurants', link: '/hotels/RestaurantList'},
                    ]
                },
                {
                    name: 'Spa', link: '#', icon: 'fas fa-spa', slug_name: 'spa-booking', children: [
                        {name: 'Manage Bookings', link: '/hotels/SpaBooking-Kanban'},
                        {name: 'Spa Booking List', link: '/hotels/SpaBookingList'},
                        {name: 'View Bookings', link: '/hotels/SpaBooking'},
                        {name: 'Manage Packages', link: '/hotels/spa-package'},
                        {name: 'Manage Package Names', link: '/hotels/spa-package-name'},
                        {name: 'Manage Therapists', link: '/hotels/ListTherapist'},
                        {name: 'Therapist Availability', link: '/hotels/TherapistAvailability'}

                    ]
                },

                {
                    name: 'Bike', link: '#', icon: 'fa fa-motorcycle', slug_name: 'bike-booking', children: [
                        {name: 'Manage Bookings', link: '/hotels/BikeBooking-kanban'},
                        {name: 'View Bookings', link: '/hotels/BikeBooking'},
                        {name: 'Manage Bike', link: '/hotels/ListBike'},


                    ]
                },
                {
                    name: 'Boat House', link: '#', icon: 'fas fa-ship', slug_name: 'boat-booking', children: [
                        {name: 'Manage Bookings', link: '/hotels/BoatBooking-kanban'},
                        {name: 'View Bookings', link: '/hotels/BoatBooking'},
                        {name: 'Manage Activity', link: '/hotels/activity'},
                        {name: 'Manage Boat', link: '/hotels/ListBoats'},
                        {name: 'Boat Booking List', link: '/hotels/BoatbookingList'},
                    ]
                },

                {
                    name: 'Room Service', link: '#', icon: 'fa fa-bed', slug_name: 'room-service-booking', children: [
                        {name: 'Manage Room Service', link: '/hotels/room-service'},
                        {name: 'Manage Item Names', link: '/hotels/item-name'},
                        {name: 'Service Availability', link: '/hotels/service-availability'},
                        {name: 'View Bookings', link: '/hotels/Roombooking'},
                        {name: 'Manage Bookings', link: '/hotels/Roombooking-kanban'},
                    ]
                },

                {
                    name: 'Amenities', link: '#', icon: 'fas fa-building', slug_name: 'amenity-booking', children: [
                        {name: 'Manage Amenities', link: '/hotels/ListAmenity'},
                        {name: 'Manage Cms Amenities', link: '/hotels/CmsAmenity'},
                        {name: 'Manage  Bookings', link: '/hotels/AmenityBooking-Kanban'},
                        {name: 'View  Bookings', link: '/hotels/AmenityBooking'},
                    ]
                },
                {
                    name: 'Check In', link: '#', icon: 'fa fa-check', slug_name: 'check-in', children: [
                        {name: 'Manage Check In', link: '/hotels/CheckInList'},
                    ]
                },
                {
                    name: 'SLA', link: '#', icon:'fas fa-clock', slug_name: 'check-in', children: [
                        {name: 'Manage SLA', link: '/hotels/SLAList'},
                    ]
                },
                {
                    name: 'Events', link: '#', icon: 'remixicon-calendar-2-fill', slug_name: 'events', children: [
                        {name: 'View All Events', link: '/hotels/ListEvent'},
                    ]
                },

                {
                    name: 'Reviews & Ratings',
                    link: '#',
                    icon: 'fa fa-thumbs-up',
                    slug_name: 'reviews-ratings',
                    children: [

                        {name: 'Map Survey Questions', link: '/hotels/ManageQuestion'},
                        {name: 'Manage Survey Questions', link: '/hotels/QuestionList'},
                        {name: 'Manage Cms Survey Questions', link: '/hotels/CmsRatingQuestion'},
                        {name: 'Reviews List', link: '/hotels/ReviewsList'},
                        {name: 'Task List', link: '/hotels/TasksList'}


                    ]
                },
                {
                    name: 'User Management',
                    link: '#',
                    icon: 'remixicon-settings-2-fill',
                    slug_name: 'user-management',
                    children: [
                        {name: 'User List', link: '/hotels/AdminList'},
                        {name: 'Role List', link: '/hotels/RoleList'},
                    ]
                },
                {
                    name: 'Beacons', link: '#', icon: 'remixicon-broadcast-fill', slug_name: 'beacons', children: [
                        {name: 'Geo Location', link: '/hotels/ListGeoLocation'},
                        {name: 'Beacon Message', link: '/hotels/ListBeaconMessage'},
                    ]
                },
            ];
            let permissions = JSON.parse(localStorage.getItem("PermissionList"));
            this.menulist = this.menulist.filter(function (value) {
                return permissions.includes(value.slug_name);
            }, permissions);
        }

    }

    ngAfterViewInit() {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);

        this._activateMenuDropdown();
    }

    ngOnChanges() {
        if (!this.isCondensed && this.sideMenu || this.isCondensed) {
            setTimeout(() => {
                this.menu = new MetisMenu(this.sideMenu.nativeElement);
            });
        } 
        else if (this.menu) {
            this.menu.dispose();
        }
    }


    getClass(path){
        return (window.location.pathname.includes(path)) ? 'active' : ''
    }
    /**
     * small sidebar
     */
    smallSidebar() {
        document.body.classList.add('left-side-menu-sm');
        document.body.classList.remove('left-side-menu-dark');
        document.body.classList.remove('topbar-light');
    }

    /**
     * Dark sidebar
     */
    darkSidebar() {
        document.body.classList.remove('left-side-menu-sm');
        document.body.classList.toggle('left-side-menu-dark');
    }

    /**
     * Light Topbar
     */
    lightTopbar() {
        document.body.classList.add('left-side-menu-dark');
        document.body.classList.add('topbar-light');
        document.body.classList.remove('left-side-menu-sm');
        document.body.classList.remove('enlarged');

    }

    /**
     * Sidebar collapsed
     */
    sidebarCollapsed() {
        document.body.classList.add('enlarged');
        document.body.classList.remove('left-side-menu-dark');
        document.body.classList.remove('left-side-menu-sm');
        document.body.classList.remove('boxed-layout');

    }

    /**
     * Boxed Layout
     */
    boxedLayout() {
        document.body.classList.toggle('boxed-layout');
        document.body.classList.remove('left-side-menu-dark');
        document.body.classList.add('enlarged');
    }

    /**
     * Activates the menu dropdown
     */
    _activateMenuDropdown() {
        const links = document.getElementsByClassName('side-nav-link-ref');
        let menuItemEl = null;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < links.length; i++) {
            // tslint:disable-next-line: no-string-literal
            if (window.location.pathname === links[i]['pathname']) {
                menuItemEl = links[i];
                break;
            }
        }

        if (menuItemEl) {
            menuItemEl.classList.add('active');

            const parentEl = menuItemEl.parentElement;
            if (parentEl) {
                parentEl.classList.add('active');

                const parent2El = parentEl.parentElement;
                if (parent2El) {
                    parent2El.classList.add('in');
                }

                const parent3El = parent2El.parentElement;
                if (parent3El) {
                    parent3El.classList.add('mm-active');
                    parent3El.firstChild.classList.add('mm-active');
                }
                // const parent4El = parent3El.parentElement;
                // if (parent4El) {
                //     menuItemEl.classList.remove('mm-active');
                //     // parent3El.classList.add('mm-active');
                //     // parent3El.firstChild.classList.add('mm-active');
                // }
            }
        }
    }

}
